import { FilterAdapter, useUrlFilterController } from 'app/components/filters/url-filters';
import { AppsFiltersStyles } from 'app/components/common/common-styles';
import Select from 'react-select';
import { DealsStatusTitles, DealStatus } from 'app/components/common/deals-statuses/deals-statuses';

export const DealsStatusAdapter: FilterAdapter<DealStatus[]> = {
  key: 'statuses',
  fromUrl: (sp) => {
    const raw = sp.get('statuses');
    if (!raw) return null;
    const arr = raw
      .split(',')
      .map((s) => s.trim())
      .filter((s) => Object.values(DealStatus).includes(s as DealStatus)) as DealStatus[];
    return arr.length ? arr : null;
  },
  toUrl: (sp, value) => {
    const next = new URLSearchParams(sp.toString());
    if (!value || value.length === 0) {
      next.delete('statuses');
    } else {
      next.set('statuses', value.join(','));
    }
    return next;
  },
  toKey: (v) => `statuses:${v && v.length ? [...v].sort().join(',') : 'all'}`
};

export const DealsStatusFilter = () => {
  const ctl = useUrlFilterController();
  const value = ctl.get(DealsStatusAdapter) ?? []; // DealStatus[] of selected statuses
  const options = Object.values(DealStatus).map((status) => ({
    value: status,
    label: DealsStatusTitles[status] || status
  }));
  const selected = options.filter((o) => value.includes(o.value));

  return (
    <Select
      isMulti
      isClearable
      isSearchable={false}
      styles={AppsFiltersStyles()}
      options={options}
      value={selected}
      placeholder="All statuses"
      onChange={(opts: any) => ctl.set(DealsStatusAdapter, opts?.map((o: any) => o.value) ?? null)}
    />
  );
};
